import { categoryZones } from '@/mocks/categories';
import SectionHeading from './SectionHeading';

const accentStyle: Record<string, { chip: string; icon: string; bar: string; link: string }> = {
  primary: {
    chip: 'bg-primary-100 text-primary-700',
    icon: 'bg-primary-500 text-background-50',
    bar: 'bg-primary-500',
    link: 'text-primary-700',
  },
  secondary: {
    chip: 'bg-secondary-100 text-secondary-900',
    icon: 'bg-secondary-500 text-background-50',
    bar: 'bg-secondary-500',
    link: 'text-secondary-700',
  },
  accent: {
    chip: 'bg-accent-100 text-accent-900',
    icon: 'bg-accent-500 text-background-50',
    bar: 'bg-accent-500',
    link: 'text-accent-700',
  },
};

export default function CategoryZones() {
  return (
    <section id="fenlei" className="bg-background-50 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          index="03"
          title="内容专区 · 四大分类"
          subtitle="娱乐瓜、网红历史、明星八卦、素人爆料，分区归档，各看各的"
          accent="accent"
        />

        <div className="space-y-5">
          {categoryZones.map((zone, index) => {
            const style = accentStyle[zone.accent] ?? accentStyle.primary;
            const reversed = index % 2 === 1;
            return (
              <article
                key={zone.id}
                className="grid grid-cols-1 lg:grid-cols-12 overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <div className={`lg:col-span-5 relative w-full h-[220px] lg:h-auto lg:min-h-[280px] ${reversed ? 'lg:order-2' : ''}`}>
                  <img
                    src={zone.cover}
                    alt={`${zone.name}专区`}
                    title={`${zone.name} 黑料投稿 内容类型`}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 flex items-center gap-2">
                    <span className={`w-9 h-9 rounded-md flex items-center justify-center text-lg ${style.icon}`}>
                      <i className={zone.icon}></i>
                    </span>
                    <span className="px-2 py-1 rounded text-[11px] bg-background-50/90 text-foreground-800 font-label tracking-wide">
                      {zone.en}
                    </span>
                  </div>
                </div>

                <div className="lg:col-span-7 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
                      <span className={`w-1 h-5 rounded-full ${style.bar}`}></span>
                      {zone.name}
                    </h3>
                    <span className={`px-2 py-0.5 rounded text-xs ${style.chip}`}>{zone.stat}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{zone.desc}</p>

                  <ul className="mt-4 divide-y divide-background-200 border-t border-background-200">
                    {zone.items.map((item) => (
                      <li key={item.title}>
                        <a
                          href="#kuaixun"
                          className="group flex items-center gap-3 py-2.5 cursor-pointer"
                        >
                          <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${style.bar}`}></span>
                          <span className="text-sm text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                            {item.title}
                          </span>
                          <span className="ml-auto text-xs text-foreground-400 whitespace-nowrap shrink-0">{item.meta}</span>
                        </a>
                      </li>
                    ))}
                  </ul>

                  <a
                    href="#kuaixun"
                    className={`mt-4 inline-flex items-center gap-1 text-xs whitespace-nowrap cursor-pointer ${style.link}`}
                  >
                    查看{zone.name}全部线索
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}